import { Button } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import CirclePatternDecorativeSVG from './CirclePatternDecorativeSVG';

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  action?: {
    label: string;
    icon?: React.ReactNode;
    onClick: () => void;
  };
  hideBackgroundImage?: boolean;
  className?: string;
}

function EmptyState({
  title,
  description,
  action,
  icon,
  hideBackgroundImage = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center h-full w-full bg-bg-secondary rounded-lg',
        className
      )}
    >
      <div className="relative w-fit">
        {!hideBackgroundImage ? <CirclePatternDecorativeSVG /> : null}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[calc(50%-32px)] flex flex-col gap-4 items-center">
          {icon}
          <div className="flex flex-col items-center gap-1">
            <h3 className="txt-medium-bold text-text-primary py-1">{title}</h3>
            <p className="txt-small-regular text-text-tertiary text-center">
              {description}
            </p>
          </div>
          {action ? (
            <Button variant="primary" className="mt-2" onClick={action.onClick}>
              {action.icon ?? null}
              <span className="txt-small-bold">{action.label}</span>
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default EmptyState;
